import type { ReactNode } from "react";
import { useWorkspaceTransport } from "./WorkspaceContext";
export function ApiLink({
  path,
  filename,
  view = false,
  reportErrors = false,
  className,
  children,
  notify,
}: {
  path: string;
  filename: string;
  view?: boolean;
  reportErrors?: boolean;
  className?: string;
  children: ReactNode;
  notify: (message: string) => void;
}) {
  const transport = useWorkspaceTransport();
  return (
    <a
      href={`/api${path}`}
      download={view ? undefined : filename}
      target={view ? "_blank" : undefined}
      rel={view ? "noreferrer" : undefined}
      className={className}
      onClick={(event) => {
        if (transport.demo && !reportErrors) return;
        event.preventDefault();
        void transport
          .download(path, filename, view)
          .catch((error) => notify(error.message));
      }}
    >
      {children}
    </a>
  );
}
